module.exports = __webpack_public_path__ + "static/media/two-factor-authentication-logo.c1b57e4f.png";